import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { NotificationsService } from '@shared/services/notifications.service';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { NavService } from '@projects/shared/src/app/services/nav.service';
import { Notification, NotificationSeverity } from '@app/core/types/notifications';
import { naturalSensitiveSort } from '@projects/shared/src/app/utils/sort';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'notifications',
  templateUrl: './notifications-updated.component.html',
  styleUrls: ['./notifications.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('400ms', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class NotificationsComponent implements OnInit {
  moment = moment;
  data: Notification[] = [];
  unreadCount = this.notificationsService.getUnreadNotificationCount();

  constructor(
    private _elementRef: ElementRef,
    public navService: NavService,
    public notificationsService: NotificationsService
  ) {
    this.notificationsService.getAllNotifications().subscribe((notifications) => {
      this.data = naturalSensitiveSort(notifications).desc('createdon');
    });
  }

  ngOnInit(): void {}

  /**
   *  Get css class names for notfication HTML element
   * @param notification      current notification data
   * @returns {string}                classNames
   */
  public getNotificationClassNames(notification: Notification): string {
    const UNREAD = 'unread';
    const ALERT = 'alert';
    const HIGH_ALERT = 'high-alert';
    const classNamePrefix = 'notification-cards--';
    let classNames = 'notification-cards ';

    if (!notification.isRead) classNames += classNamePrefix + UNREAD + ' ';
    switch (notification.serverity) {
      case NotificationSeverity.ALERT:
        classNames += classNamePrefix + ALERT;
        break;
      case NotificationSeverity.HIGH_ALERT:
        classNames += classNamePrefix + HIGH_ALERT;
        break;
      default:
        break;
    }

    return classNames;
  }
  /**
   * For click outside of the calendar's container
   * @param event event object
   */
  @HostListener('document:click', ['$event'])
  outsideClick(event: any): void {
    if (!event.target) {
      return;
    }

    if (event.target.classList.contains('flecx_notification_icon')) {
      return;
    }

    if (!this._elementRef.nativeElement.contains(event.target) && this.navService.getNotificationPane() === true) {
      this.navService.toggleNotificationPane();
    }
  }
}
